<template>
  <div class="navbar">
    <breadcrumb class="breadcrumb-container hidden-sm-and-down"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'


export default {
  components: {
    Breadcrumb
  },
  computed: {
    ...mapGetters([
      'avatar'
    ])
  },
  data() {
    return {}
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.navbar {
  height: 38px;
  overflow: hidden;
  position: relative;
  background-color: #F1F4F9;

  .breadcrumb-container {
    float: left;
  }
}
</style>
